import gql from 'graphql-tag';

import { fileFragment } from '~/shared/graphql-queries/files/index';

export default gql`
  mutation updateByIdFileMutation(
    $_id: MongoID!
    $record: UpdateByIdFileInput!
  ) {
    updateByIdFileMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...FileFragment
      }
      message
      title
    }
  }
  ${fileFragment}
`;
